// ScaleContext.js
import React from 'react';

const IframeCSSContext = React.createContext(false); // Default scale is 1

export default IframeCSSContext;
